import { useEffect } from "react"

export function MonitorClientError({
  error,
  scope,
}: {
  error: Error & { digest?: string }
  scope: "global" | "dashboard" | "admin" | "public"
}) {
  useEffect(() => {
    void fetch("/api/client-errors", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        message: error.message || "Unknown client error",
        digest: error.digest,
        path: window.location.pathname,
        scope,
      }),
      keepalive: true,
    }).catch(() => undefined)
  }, [error, scope])

  return null
}
